import axios from "axios";
import api from '../api/'
module.exports = {
    login: function (username, password, callback) {
        this.getToken(
            username,
            password,
            (response) => {
                this.updateLocalStorage(response.data);
                if (callback) callback({ "success": true });
            },
            (errors) => {
                if (callback) callback({ "success": false, "errors": errors.errors });
            })
    },

    changePassword: function (actual, password, repassword, callback) {
        this.updatePassword(
            actual,
            password,
            repassword,
            (response) => {
                this.updateLocalStorage(response.data);
                if (callback) callback({ "success": true });
            },
            (errors) => {
                if (callback) callback({ "success": false, "errors": errors.errors });
            })
    },

    sessionTimeoutLogin: function (public_token, token, password, callback) {
        var response = axios.post(api.authCheckWithToken, {
            token: token,
            password: password
        }, this.header(token, public_token)).then(response => {
            if (response.status == 200) {
                let data = response.data.data;
                this.updateLocalStorage(data);
                if (callback) callback({ "success": true });
            } else {
                if (callback) callback({ "success": false, "errors": response.errors });
            }
        }).catch(response => {
            if (callback) callback({ "success": false, "errors": response.errors });
        });
    },

    logout: function () {
        axios.get(
            api.authLogout,
            this.header()
        ).then(function (response) {
            delete localStorage.token_gestion;
            delete localStorage.permisos_gestion;
            window.location.reload();
        }).catch(function (e) {
        })
    },

    isLoggedIn: async function () {
        try{
            if(
                typeof (localStorage.token_gestion) != "undefined" &&
                typeof (localStorage.public_token_gestion) != "undefined"
            ) {
                var response =
                    await this.checkToken(localStorage.token_gestion, localStorage.public_token_gestion);
                if (response.exists) {
                    return response;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } catch (e) {
            delete localStorage.token_gestion;
            delete localStorage.permisos_gestion;
            delete localStorage.public_token_gestion;

            return false;
        }

    },

    clearToken: function (callback) {
        axios.get(api.clearToken, this.header()).then(response => { if (callback) callback(response.data.data) });
        delete localStorage.token_gestion;
        delete localStorage.permisos_gestion;
        delete localStorage.public_token_gestion;
    },

    checkToken: async function (token, public_token) {
        let reply = (await axios.post(api.authCheck, {
            token: token,
            public_token: public_token
        }));
        this.updateLocalStorage(reply.data.data);
        return reply.data.data;
    },



    hasPermission: function (permission) {
        if (localStorage.permisos_gestion != "" && localStorage.permisos_gestion != undefined) {
            var permisos = JSON.parse(localStorage.permisos_gestion);
            if (permisos.filter(x => x == permission).length > 0) {
                return true;
            } else {
                return false;
            }
        }
    },

    updatePermission: function () {
        var self = this;
        axios.get(api.authGetPermissions, self.header()).then(function (response) {
            if (response.status == 200) {
                let data = response.data.data;
                localStorage.permisos_gestion = JSON.stringify(data.permisos);
            } else {
                self.logout();
            }
        })
    },

    token: function () {
        return localStorage.token_gestion;
    },

    header: function (token, public_token) {
        return {
            headers: {
                "Authorization": "Token " + (token ? token : localStorage.token_gestion),
                "Public-Token":  public_token ? public_token :localStorage.public_token_gestion
            },
        };
    },

    fileFormHeader: function (token) {
        return {
            headers: {
                "Authorization": "Token " + (token ? token : localStorage.token_gestion),
                "Content-Type": "multipart/form-data"
            },
            async: false,
            cache: false,
            contentType: false,
            processData: false,
        };
    },


    updatePassword: function (actual_password, new_password, repeat_new_password, callback, errorCallback) {
        axios.post(api.authChangePassword, {
            actual_password: actual_password,
            new_password: new_password,
            repeat_new_password: repeat_new_password,
        }, this.header()).then(function (response) {
            if (response.status == 200) {
                if (callback) callback(response.data);
            } else {
                if (errorCallback) errorCallback({
                    "success": false
                });
            }
        }).catch(function (e) {
            if (errorCallback) errorCallback({
                "success": false
            })
        })
    },

    getToken: function (username, password, callback, errorCallback) {
        axios.post(api.auth, {
            username: username,
            password: password,
        }).then(function (response) {
            if (response.status == 200) {
                if (callback) callback(response.data);
            } else {
                if (errorCallback) errorCallback({
                    "success": false
                });
            }
        }).catch(function (e) {
            if (errorCallback) errorCallback({
                "success": false
            })
        })
    },

    updateLocalStorage: function (data) {
        if (data.token != undefined) localStorage.token_gestion = data.token;
        if (data.permisos != undefined) localStorage.permisos_gestion = JSON.stringify(data.permisos);
        if (data.configuraciones != undefined) localStorage.configuraciones_gestion = JSON.stringify(data.configuraciones);
        if (data.displayname != undefined) localStorage.displayname_gestion = data.displayname;
        if (data.iduser != undefined) localStorage.iduser_gestion = data.iduser;
        if (data.driver != undefined) localStorage.driver_gestion = data.driver;
        if (data.public_token != undefined) localStorage.public_token_gestion = data.public_token;
    }
}



// WEBPACK FOOTER //
// ./src/auth/auth.js